import { AnalyticsClient } from './client'
// import { Http } from './http';

// const analyticsClient = new AnalyticsClient(new Http());

// if (window) {
//   if (window['GlobalE']) {
//     window['GlobalE']['AnalyticsSdk'] = analyticsClient;
//   } else {
//     window['AnalyticsSdk'] = analyticsClient;
//   }
// }

export default AnalyticsClient;
